import AddressSwitcherBar from 'components/address-switcher-bar/AddressSwitcherBar.tsx'
import { Card, Heading } from '@boltenergy-be/design-system'
import { useTranslation } from 'react-i18next'
import DiscountHistory from './components/discount-history/DiscountHistory.tsx'
import DiscountsForm from './components/discounts-form/DiscountsForm.tsx'

const TariffsDiscounts = () => {
  // i18n
  const { t: tDiscounts } = useTranslation('tariffs', { keyPrefix: 'discounts' })

  return (
    <>
      <AddressSwitcherBar />

      <Card as="section">
        <Card.Title variant="h4" serif={false}>
          {tDiscounts(($) => $.new.title)}
        </Card.Title>

        <DiscountsForm />
      </Card>

      <section className="flex-col gap-500">
        <Heading as="h2" variant="h5">
          {tDiscounts(($) => $.history.title)}
        </Heading>

        <DiscountHistory />
      </section>
    </>
  )
}

export default TariffsDiscounts
